import React from "react";
import { Formik } from "formik";
import { injectIntl, FormattedMessage } from "react-intl";

import { updatePassword } from "../../services/moocfi";
import StyledForm from "../StyledForm";
import { Error, Success, SubmitButton } from "./AccountFormStyles";
import _ from "lodash";

const initialState = () => ({
  currentPassword: "",
  password: "",
  confirmPassword: ""
});

const formStatus = {
  SUBMITTED: "SUBMITTED"
};

class PasswordChangeForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = initialState();
  }

  render() {
    const onSubmit = (
      values,
      { setSubmitting, setErrors, setValues, setStatus }
    ) => {
      setSubmitting(true);
      setStatus(null);
      updatePassword(
        values.currentPassword,
        values.password,
        values.confirmPassword
      ).then(
        res => {
          setSubmitting(false);
          setValues(initialState());
          setStatus(formStatus.SUBMITTED);
        },
        res => {
          setSubmitting(false);
          console.log("Password update failed", res);
          if (res.status === 403) {
            setErrors({
              form: this.props.intl.formatMessage({ id: "pwChange.authError" })
            });
          } else if (res.status === 500) {
            setErrors({
              form: this.props.intl.formatMessage({
                id: "pwChange.unexpError"
              })
            });
          } else {
            const errors = _.get(res, "data.errors", {});
            setErrors(mapServerErrorsToFormErrors(errors));
          }
        }
      );
    };

    const mapServerErrorsToFormErrors = serverErrors => ({
      currentPassword: _.get(serverErrors, "old_password", null),
      password: _.get(serverErrors, "password", null),
      confirmPassword: _.get(serverErrors, "password_repeat", null)
    });

    const validate = values => {
      let errors = {};
      if (_.isEmpty(values.currentPassword)) {
        errors.currentPassword = this.props.intl.formatMessage({
          id: "pwChange.required"
        });
      }

      if (_.isEmpty(values.password)) {
        errors.password = this.props.intl.formatMessage({
          id: "pwChange.required"
        });
      }

      if (values.password !== values.confirmPassword) {
        errors.confirmPassword = this.props.intl.formatMessage({
          id: "pwChange.pwMustMatch"
        });
      }

      return errors;
    };

    return (
      <div>
        <Formik
          initialValues={this.state}
          onSubmit={onSubmit}
          validateOnBlur={false}
          validateOnChange={false}
          validate={validate}
          render={({
            values,
            errors,
            isValid,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
            status
          }) => (
            <StyledForm>
              <form onSubmit={handleSubmit}>
                <fieldset>
                  <label htmlFor="currentPassword">
                    <FormattedMessage id="pwChange.currentPassword" />
                  </label>
                  <input
                    value={values.currentPassword}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    type="password"
                    id="currentPassword"
                    name="currentPassword"
                    placeholder={this.props.intl.formatMessage({
                      id: "pwChange.currentPassword"
                    })}
                  />
                  {touched.currentPassword && errors.currentPassword && (
                    <Error>{errors.currentPassword}</Error>
                  )}

                  <label htmlFor="password">
                    <FormattedMessage id="pwChange.newPassword" />
                  </label>
                  <input
                    value={values.password}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    type="password"
                    id="password"
                    name="password"
                    placeholder={this.props.intl.formatMessage({
                      id: "pwChange.newPassword"
                    })}
                  />
                  {touched.password && errors.password && (
                    <Error>{errors.password}</Error>
                  )}

                  <label htmlFor="confirmPassword">
                    <FormattedMessage id="pwChange.confirmPassword" />
                  </label>
                  <input
                    value={values.confirmPassword}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    type="password"
                    id="confirmPassword"
                    name="confirmPassword"
                    placeholder={this.props.intl.formatMessage({
                      id: "pwChange.confirmPassword"
                    })}
                  />
                  {touched.confirmPassword && errors.confirmPassword && (
                    <Error>{errors.confirmPassword}</Error>
                  )}
                </fieldset>
                <fieldset>
                  {errors.form && <Error>{errors.form}</Error>}
                </fieldset>
                <SubmitButton type="submit" disabled={isSubmitting}>
                  {this.props.intl.formatMessage({
                    id: isSubmitting
                      ? "pwChange.changingPassword"
                      : "pwChange.changePassword"
                  })}
                </SubmitButton>
                {status === formStatus.SUBMITTED && (
                  <Success>
                    <FormattedMessage id="pwChange.passwordChanged" />
                  </Success>
                )}
              </form>
            </StyledForm>
          )}
        />
      </div>
    );
  }
}

export default injectIntl(PasswordChangeForm);
